module.exports = __webpack_public_path__ + "img/ic_telefon_xsmall.ef1385a4.svg";